<template>
  <div>
    <table-items :items="items" :restoreState="false"/>
    <div class="row pt-3">
      <div class="mt-3 color">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Pagination from "../../components/dashboard/Pagination";
import tableItems from "../../components/dashboard/Loan/tableItems.vue";
import {loan_status} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Loan'


export default {
  name: "LoansAdmin",
  components: {tableItems, Pagination},
  data() {
    return {
      searchWords: '',
      orderStatusValue: '',
      loan_status,
    }
  },
  computed: {
    ...mapGetters({
      items: "Loan/getLoans",
      paginationMeta: "Loan/getPaginationMeta",
      isAdmin: 'User/isAdmin'
    }),
  },
  methods: {
    changePage(page) {
      const form = {
        user_id: this.$store.getters['User/getUserId'],
        page: page
      }
      this.$store.dispatch("Loan/getUserLoans", form);
    },
  },
  async mounted() {
    const form = {
      user_id: this.$store.getters['User/getUserId'],
      page: 1
    }
    await this.$store.dispatch("Loan/getUserLoans", form);
  },
};
</script>